<template>
    <base-layout title="会员中心" :hideHeader="true">
        <template slot="main">
            <div class="member-body">
                <div class="member-nav" :style="navStyle">
                    <ul class="title-container">
                        <li @click="back()">
                            <i class="dmicon dm-xiangzuojiantou"></i>
                            <span>返回</span>
                        </li>
                        <li>
                            <span></span>
                        </li>
                        <li class="title-right" @click="toMemberRules">
                            <span>查看《会员章程》</span><i class="dmicon dm-xiangyoujiantou"></i>
                        </li>
                    </ul>
                </div>
                <div class="main-body-content" @scroll.passive="paperScroll($event)">
                    <div class="notice-container" @click="toPage">
                        <img v-if="loyaltyLevel>0" src="./_img/notice/会员权益概览-立即订餐.jpg">
                        <img v-else src="./_img/notice/会员权益概览-立即入会.jpg">
                        <!--<viewer>
                        </viewer>-->
                    </div>
                </div>
            </div>
        </template>
    </base-layout>
</template>

<script>
	// 大邦图标组件
	import dIcon from '@components/comm/d-icon.vue'
	import baseLayout from '@comm/view/layout/baseLayout';
	import circleProgress from '@components/comm/circle-progress.vue'
	// loading加载
    import loading from '@components/comm/loading'
    // 用户存储
    import userStore from '@comm/store/user/userInfo.store.js'

	// 第一阶段缩放比例
	const oneScale = 0.55;
	// 进度刻量图标比例
	const logProgress = 0.05

	const num = 2;

	export default {
		name: 'myMemberNotice',
		components: {
			dIcon,
			loading,
			baseLayout,
			circleProgress,
		},
		data() {
			return {
				// 滚动比例
				scrollScale: 0,
				// 积分
				point: 300,
				// 是否回馈礼
				isFeedback: false,
				isLogin: String(this.$route.query.isLogin || false) == 'true',
				loyaltyLevel: this.$route.query.loyaltyLevel || 0,
			}
		},
		created() {

		},
		mounted() {
			// 神策埋点
            this.$Sensors.track("SecondLevelPageView", {});
		},
		methods: {
			// 页面返回
			back() {
				if (this.$fromPath && ['/my/member/privilege'].indexOf(this.$fromPath.path) === -1) {
					return this.$backPage();
				}
				return this.$router.push('/');
			},
			// 页面滚动
			paperScroll(event) {
				let srcElement = event.srcElement;
				let scrollTop = srcElement.scrollTop;
				let gap = 50 - scrollTop;
				let scale = 1;
				if (gap > 0) {
					scale = scrollTop / 50;
				}
				this.scrollScale = scale;
			},
			toPage() {
				let url = this.isLogin ? this.loyaltyLevel > 0 ? '/menu' : '/addMember' : '/login';
				this.$router.push(url);
                // 神策埋点
                this.$Sensors.track("SecondLevelPageClick", {
                    button_name: (this.isLogin && this.loyaltyLevel > 0) ? "立即订餐" : "立即入会"
                });

			},
			// 跳转会员章程页面
			toMemberRules() {
                this.$CDP.track('c_check_mem_policy', {
                    // 按钮名称/图片
                    c_buttonName: "会员权益",
                    // 按钮id
                    c_buttonId: "",
                })
                // 神策埋点
                this.$Sensors.track("SecondLevelPageClick", {
                    button_name: "查看会员章程"
                });

				this.$router.push({
					path: "/system/protocol/memberRules?type=simple",
				})
			}
		},
		computed: {
			// nav 样式
			navStyle() {
				let color = `rgba(255, 255, 255, ${1 - this.scrollScale})`;
				if (this.scrollScale > 0.5) {
					color = `rgba(0, 0, 0, ${this.scrollScale - (0.5 * (1 - this.scrollScale))})`;
				}
				return {
					color: color,
					boxShadow: `rgba(44, 44, 44, ${this.scrollScale}) -1px 0px 5px`,
					background: `rgba(255, 255, 255, ${this.scrollScale})`
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
    $headerBgColor: #2E2520;
    $padding: 15px;
    $headerHeight: 55px;
    $cardColor: #745227;
    $vipScale: 55%;
    .member-body {
        height: 100%;
        overflow: hidden;
        position: relative;
    }

    .main-body-content, .main-container, .time-title, .explain-container, .pizza-container {
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
    }

    .main-body-content {
        height: 100%;
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .member-nav {
        top: 0;
        width: 100%;
        height: $headerHeight;
        z-index: 10;
        position: absolute;
        ul {
            height: 100%;
            display: flex;
            align-content: center;
            align-items: center;
            flex-direction: row;
            flex-flow: row nowrap;
            justify-content: space-evenly;
        }
        li {
            flex-grow: 1;
            height: 100%;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            &:not(:nth-child(2)) {
                width: 2rem;
                flex-grow: 0;
                font-weight: 600;
            }
            &:nth-child(2) {
                span {
                    /*color: #fbe7bb;*/
                    font-size: 24px;
                    font-weight: 900;
                }
            }
            &:first-child {
                span {
                    font-size: 16px;
                }
                i {
                    font-size: .5rem;
                }
            }
            &:last-child {
                i {
                    top: -5px;
                    font-weight: 100;
                    font-size: 26px;
                    position: relative;
                }
            }

            i {
                width: .5rem;
                height: .5rem;
            }
        }
    }

    /deep/ {
        .van-circle {
            transform: initial !important;
        }
    }

    .notice-container {
        width: 100%;
        min-height: 100%;
        img {
            width: 100%;
        }
    }

    .member-nav > .title-container {
        .title-right {
            color: red;
            width: 4.5rem;
            display: flex;
            align-items: center;
            align-content: center;
            span{
                font-size: 16px;
            }
            i{
                padding-top: 5px;
                font-size: 18px;
                display: inline;
                font-weight: 800;
            }

        }
    }


</style>